import React, { useState, useEffect } from "react";
import { Button, Col, Spinner, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../services";
import "./Profiles.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // Import UTC plugin
import { motion } from "framer-motion";

import customParseFormat from "dayjs/plugin/customParseFormat";

import {
  PersonCircle,
  Telephone,
  Envelope,
  CardChecklist,
  CalendarDate,
  GenderAmbiguous,
  Briefcase,
  Heart,
  PersonVcard,
} from "react-bootstrap-icons";
import { cls } from "react-image-crop";

// Enable dayjs UTC plugin
dayjs.extend(utc);
dayjs.extend(customParseFormat);


const Profiles = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [emailError, setEmailError] = useState("");
  const userData = useSelector((state) => state.users);
  const navigate = useNavigate();

  const [editData, setEditData] = useState({
    fullName: userData.users.clientDetails.fullName,
    phoneNumber: userData.users.clientDetails.phoneNumber,
    dateOfBirth: userData.users.clientDetails.dateOfBirth,
    cniExpiryDate: userData.users.clientDetails.cniExpiryDate,
    gender: userData.users.clientDetails.gender,
    cniNumber: userData.users.clientDetails.cniNumber,
    email: userData.users.clientDetails.email,
    occupation: userData.users.clientDetails.occupation,
    cniIssueDate: userData.users.clientDetails.cniIssueDate,
    maritalStatus: userData.users.clientDetails.maritalStatus,
  });
  console.log("user___data", userData)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [formData, setFormData] = useState(userData.users.clientDetails)

  useEffect(() => {
    const clientId = userData.users.clientDetails?.phoneNumber || "";
    const token = userData.users.token || "";

    const abortController = new AbortController();
    const { signal } = abortController;


    const fetchClientInfo = async () => {
      if (!clientId || !token) return;

      try {
        const requestData = {
          serviceReference: "GET_CLIENT_BY_INSURANCE_CODE",
          requestBody: clientId,
        };

        setLoading(true);
        const response = await apiRequest(
          "GATEWAY",
          "",
          "POST",
          requestData,
          token,
          dispatch,
          navigate
        );
        if (response?.status === 200) {
          console.log("fetch client infos===",response.body)
          setFormData(response.body.data);
          setEditData(response.body.data);
        }
      } catch (error) {
        if (!signal.aborted) {
          console.error("Fetch error:", error);
        }
      } finally {
        if (!signal.aborted) {
          setLoading(false);
        }
      }
    };

      fetchClientInfo();

      return () => abortController.abort();
  }, []);
  // }, [userData.users.clientDetails?.clientId, userData.users.token]);

  const hasNAValues = () => {
    const fields = [
      formData.fullName,
      formData.clientId,
      formData.phoneNumber,
      formData.dateOfBirth,
      formData.cniExpiryDate,
      formData.gender,
      formData.cniNumber,
      formData.email,
      formData.occupation,
      formData.cniIssueDate,
      formData.maritalStatus,
    ];
    console.log(">>>>>>>>>>>=============>>>>>",fields)
    return fields.some((field) => !field || field === "N/A");
  };

  const validateEmail = (email) => {
    if (!email || email === "N/A") return true;
    return emailRegex.test(email);
  };

  const handleInputChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
    if (field === "email") {
      setEmailError(validateEmail(value) ? "" : t("invalidEmailFormat"));
    }
  };



  const handleUpdate = async () => {
    if (emailError || !validateEmail(editData.email)) {
      setEmailError(t("invalidEmailFormat"));
      return;
    }

    try {
      setLoading(true);
      const payload = {
        fullName: editData.fullName,
        phoneNumber: editData.phoneNumber,
        dateOfBirth: editData.dateOfBirth,
        cniExpiryDate: editData.cniExpiryDate,
        gender: editData.gender,
        cniNumber: editData.cniNumber,
        email: editData.email,
        occupation: editData.occupation,
        cniIssueDate: editData.cniIssueDate,
        maritalStatus: editData.maritalStatus,
        msisdn: editData.phoneNumber,
      };

      const cleanedPayload = Object.fromEntries(
          Object.entries(payload).filter(
              ([_, value]) => value !== undefined
          )
      );

      console.log("edit form data", cleanedPayload)

      const requestData = {
        serviceReference: "UPDATE_CLIENT_INFO",
        requestBody: JSON.stringify(cleanedPayload),
      };

      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );

      if (response?.status === 200) {
        dispatch({
          type: "SET_CLIENT_DETAILS",
          value: response.body.data,
        });

        setFormData((prev) => ({ ...prev, ...cleanedPayload }));
        setIsEditing(false);
        setEmailError("");
      }
      console.log("response is ", response);
    } catch (error) {
      console.error("Update error:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderInfoItem = (label, value, field, icon) => (
    <motion.li
      className="profiles-info-item"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
    >
      <span className="profiles-info-label">
        {icon} {t(label)}:
      </span>
      {isEditing && (!value || value === "N/A") && field === "gender" ? (
        <Form.Select
          value={editData[field] || ""}
          onChange={(e) => handleInputChange(field, e.target.value)}
          className="profiles-input"
        >
          <option value="">{t("selectGender")}</option>
          <option value="Male">{t("male")}</option>
          <option value="Female">{t("female")}</option>
        </Form.Select>
      ) : isEditing &&
        (!value || value === "N/A") &&
        field === "maritalStatus" ? (
        <Form.Select
          value={editData[field] || ""}
          onChange={(e) => handleInputChange(field, e.target.value)}
          className="profiles-input"
        >
          <option value="">{t("Selectionner votre status civil")}</option>
          <option value="Celibataire">{t("single")}</option>
          <option value="Marier">{t("married")}</option>
          <option value="Divorcé">{t("divorced")}</option>
        </Form.Select>
      ) : isEditing && (!value || value === "N/A") ? (
        <div>
          <Form.Control
            type={field.includes("Date") ? "date" : "text"}
            value={editData[field] || ""}
            onChange={(e) => handleInputChange(field, e.target.value)}
            className="profiles-input"
            placeholder={field === "email" ? "example@domain.com" : ""}
          />
          {field === "email" && emailError && (
            <Form.Text className="text-danger">{emailError}</Form.Text>
          )}
        </div>
      ) : (
        <span className="profiles-info-value">{value || "N/A"}</span>
      )}
    </motion.li>
  );


function formatDateOfBirth(dateOfBirth) {
  console.log(">>>>>>+++++>Date of birth", dateOfBirth);

  if (!dateOfBirth || dateOfBirth === "N/A") {
    return "N/A";
  }

  try {
    const date = dayjs.utc(dateOfBirth, "DD/MM/YYYY", true);

    if (!date.isValid()) {
      console.error("Invalid date format:", dateOfBirth);
      return "N/A";
    }

    console.log(">>>>>>+++++>Formatted date", date.format("YYYY-MM-DD"));
    return date.format("YYYY-MM-DD");

  } catch (error) {
    console.error("Error formatting date:", dateOfBirth, error);
    return "N/A";
  }
}


  // let test = (dateOfBirth) =>{
  //   var dateOfBirch = formatDateOfBirth(dateOfBirth)
  //   console.log(">>>>>>+++++>Date of birth test 2", dateOfBirch)

  // }

  const translateGender = (gender) => {
    if (gender === "Male") return t("male");
    if (gender === "Female") return t("female");
    return gender || "N/A";
  };

  const translateCivilStatus = (status) => {
    switch (status) {
      case "Single":
        return t("single");
      case "Married":
        return t("married");
      case "Divorced":
        return t("divorced");
      case "Widowed":
        return t("widowed");
      default:
        return status || "N/A";
    }
  };

  return (
    <div>
      <motion.div
        className="beneficiary"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="profiles-overlay-text">
          <PersonCircle className="me-2" /> {t("completeSubscription")}
        </div>
      </motion.div>

      <div className="profiles-cards p-4" style={{ marginBottom: "2rem" }}>
        <motion.div
          className="d-flex justify-content-between flex-wrap align-items-center"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="d-flex align-items-center">
            <h2>
              {t("Profil")}{" "}
              <span className="profiles-insurance-code">
                ({userData?.users?.clientDetails?.clientId})
              </span>
            </h2>
          </div>
          <div className="profiles-button-container">
            {hasNAValues() ? (
              <p className="text-danger">
                {t("completeYourInformationToAccessInsurance")}
              </p>
            ) : (
              <>
                <Button
                  className="profiles-action-button"
                  onClick={() => navigate("/beneficiary")}
                >
                  <PersonCircle className="me-2" /> {t("addBeneficiary")}
                </Button>
                <Button
                  className="profiles-action-button"
                  onClick={() => navigate("/declaration")}
                >
                  <CardChecklist className="me-2" /> {t("declaration")}
                </Button>
              </>
            )}
          </div>
        </motion.div>

        {loading ? (
          <motion.div
            className="text-center mt-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <Spinner animation="border" variant="primary" />
            <p>{t("loadingClientInfo")}...</p>
          </motion.div>
        ) : (
          <motion.div
            className="profiles-card p-4 mt-4"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="profiles-list">
              <ul className="row">
                <Col md={6}>
                  {renderInfoItem(
                    "fullName",
                    formData.fullName,
                    "fullName",
                    <PersonCircle className="me-2" />
                  )}
                  {renderInfoItem(
                    "phoneNumber",
                    formData.phoneNumber,
                    "phoneNumber",
                    <Telephone className="me-2" />
                  )}
                  {renderInfoItem(
                    "dateOfBirth",
                    formatDateOfBirth(formData.dateOfBirth),
                    // test(formData.dateOfBirth),
                    "dateOfBirth",
                    <CalendarDate className="me-2" />
                  )}
                  {renderInfoItem(
                    "cniExpiryDate",
                    formatDateOfBirth(formData.cniExpiryDate),
                    "cniExpiryDate",
                    <CalendarDate className="me-2" />
                  )}
                  {renderInfoItem(
                    "gender",
                    translateGender(formData.gender),
                    "gender",
                    <GenderAmbiguous className="me-2" />
                  )}
                </Col>
                <Col md={6}>
                  {renderInfoItem(
                    "nationalId",
                    formData.cniNumber,
                    "cniNumber",
                    <PersonVcard className="me-2" />
                  )}
                  {renderInfoItem(
                    "email",
                    formData.email,
                    "email",
                    <Envelope className="me-2" />
                  )}
                  {renderInfoItem(
                    "occupation",
                    formData.occupation,
                    "occupation",
                    <Briefcase className="me-2" />
                  )}
                  {renderInfoItem(
                    "cniIssueDate",
                    formatDateOfBirth(formData.cniIssueDate),
                    "cniIssueDate",
                    <CalendarDate className="me-2" />
                  )}
                  {renderInfoItem(
                    "maritalStatus",
                    translateCivilStatus(formData.maritalStatus),
                    "maritalStatus",
                    <Heart className="me-2" />
                  )}
                </Col>
              </ul>
            </div>
            {hasNAValues() && (
              <motion.div
                className="text-center mt-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <Button
                  className="profiles-action-button"
                  onClick={() =>
                    isEditing ? handleUpdate() : setIsEditing(true)
                  }
                  disabled={loading || emailError}
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : isEditing ? (
                    t("updateInformation")
                  ) : (
                    t("editInformation")
                  )}
                </Button>
              </motion.div>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Profiles;
